import { render } from "./Home.vue?vue&type=template&id=248674e7&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=248674e7&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248674e7"]])

export default __exports__